const styles = () => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  icon: {
    color: '#dd7c00',
  },
  interactive: {
    '&:not($disabled)': {
      '& $icon:hover': {
        cursor: 'pointer',
        color: '#ffd300',
      },
    },
  },
  cursorNotAllowed: {
    cursor: 'not-allowed',
  },
  disabled: {},
});

export default styles;
